// Used for updating a single value in the reducer
export default function updateSingleValue(valueName) {
  return (state, value) => Object.assign({}, state, { [valueName]: value })
}



// WEBPACK FOOTER //
// ./src/helpers/updateSingleValue.js